export default __webpack_public_path__ + "static/media/cover5.eae28089.jpeg";